import React from 'react';
import { useAppState } from '../../contexts/AppStateContext';
import { DEMO_DATE } from '../../data/demo';
import { addDays, formatShortDay } from '../../utils/time';
import { isDoneStatus } from '../../utils/progress';
export function WeeklySummary() {
  const {
    family,
    familyOcc,
    db,
    activeMembers,
    memberById
  } = useAppState();
  const next = family.events.filter(e => e.date >= DEMO_DATE && e.date <= addDays(DEMO_DATE, 7)).sort((a, b) => (a.date + a.start).localeCompare(b.date + b.start));
  const house = family.templates.filter(t => t.group === 'hisa' && t.frequency?.kind === 'tedensko' && !t.planKey);
  const houseDone = house.filter(t => familyOcc[t.id]?.status === 'potrjeno').length;
  const careDone = family.templates.filter(t => t.group === 'zivali' && isDoneStatus(familyOcc[t.id]?.status)).length;
  const minutes = db.entries.filter(e => e.familyId === family.id).reduce((s, e) => s + e.minutes, 0);
  const tests = db.schoolItems.filter(s => s.familyId === family.id && s.kind === 'test' && !s.done);
  const stats: [string, string][] = [['Hišne kategorije potrjene', `${houseDone}/${house.length}`], ['Oskrb živali danes', `${careDone}`], ['Zapisanih minut dejavnosti', `${minutes}`], ['Člani', `${activeMembers.length}`]];
  return <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_300px]" data-id="element-263" data-mp="1f62jzfxjldgg">
      <div data-id="element-264" data-mp="1f7do5guwgn83">
        <h3 className="font-display text-lg font-semibold" data-id="element-265" data-mp="ifa7es9ti3jf">Naslednjih 7 dni</h3>
        <ul className="mt-2 divide-y divide-line rounded-3xl border-[1.5px] border-line bg-surface" data-id="element-266" data-mp="ihmvln665a4x">
          {next.length === 0 && <li className="px-4 py-3 text-sm text-muted" data-id="element-267" data-mp="rg88b1oyluxs">Mirni dnevi pred nami.</li>}
          {next.map(e => <li key={e.id} className="flex gap-3 px-4 py-2.5 text-sm" data-id="element-268" data-mp="wfbguw45ejai">
              <span className="w-20 shrink-0 font-bold capitalize text-muted" data-id="element-269" data-mp="22v40lqgj3uwt">{formatShortDay(e.date)}</span>
              <span className="min-w-0 flex-1 font-semibold" data-id="element-270" data-mp="27tyfihbdkzbn">
                {e.start} {e.title}
              </span>
              {e.needsDriver && !e.driverId && <span className="text-xs font-bold text-review-ink" data-id="element-271" data-mp="1i4hxroffwj8v">prevoz?</span>}
            </li>)}
        </ul>
        {tests.length > 0 && <>
            <h3 className="mt-5 font-display text-lg font-semibold" data-id="element-272" data-mp="1s4ikzlgfjjic">Testi na obzorju</h3>
            <ul className="mt-2 space-y-1 text-sm" data-id="element-273" data-mp="1n4mhrofk3w3u">
              {tests.map(t => <li key={t.id} data-id="element-274" data-mp="zfbkigxf0jug">
                  <b data-id="element-275" data-mp="zgcyou9q9mge">{memberById(t.memberId)?.name}</b>: {t.title} ({formatShortDay(t.date)})
                </li>)}
            </ul>
          </>}
      </div>
      <dl className="space-y-2 rounded-3xl bg-canvas p-4" data-id="element-276" data-mp="195wf7t9yx483">
        {stats.map(([k, v]) => <div key={k} className="flex items-baseline justify-between gap-3" data-id="element-277" data-mp="14e4nvgizmugw">
            <dt className="text-sm text-muted" data-id="element-278" data-mp="gp3muechilln">{k}</dt>
            <dd className="font-display text-xl font-semibold tabular-nums" data-id="element-279" data-mp="gnitgs1wp8pd">{v}</dd>
          </div>)}
      </dl>
    </div>;
}